export const getUpgradeable = license => {
  if (!license) return;
  if (license.config.product === 'old') {
    return {
      toAI: true,
    };
  }
};
